/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import styled from "styled-components";
import { Dimensions, HideAbleImageProps, StyledPictureProps } from "./Image.types.js";

export const HideAbleImage = styled.img<HideAbleImageProps>`
    display: ${({ hidden }) => (hidden ? "none" : "block")};
`;

export const StyledPicture = styled.picture<StyledPictureProps>`
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    aspect-ratio: ${({ aspectRatio }) => aspectRatio};
    overflow: hidden;
    background: ${({ background }) => background};
    > img,
    > [data-element="loader"] {
        object-fit: ${({ objectFit }) => objectFit || "cover"};
        object-position: center;
        height: 100%;
        width: 100%;
        max-height: 100%;
        max-width: 100%;
    }
    > [data-element="loader"] {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    ${({ dimensions }) =>
        !dimensions
            ? undefined
            : Object.keys(dimensions).reduce<string>(
                  (acc, key) => acc.concat(`${key.replace(/[A-Z]/g, (m) => `-${m.toLocaleLowerCase()}`)}: ${dimensions[key as keyof Dimensions]};`),
                  "",
              )}
`;
